export const environment = {
  production: false,
  BASE_URL: 'https://controlapi.truphle.com/',
};
